import { AvailableModules } from 'generated/featureDefinitions'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

interface OnClickProps {
  onClick?: () => void
  requestSource: string
  moduleRequested: AvailableModules
  component: string
  setOpenUpsellModal: (open: boolean) => void
}

interface OnCloseProps {
  onClose?: () => void
  requestSource: string
  moduleRequested: AvailableModules
  component: string
}

interface VisibilityProps {
  moduleRequested: AvailableModules
  requestSource: string
  component: string
}

export const handleUpsellingOnClick = ({
  onClick,
  requestSource,
  moduleRequested,
  component,
  setOpenUpsellModal,
}: OnClickProps) => {
  if (onClick) {
    onClick()
  }

  setOpenUpsellModal(true)

  track(trackingEvents.upsellingKit.clickProductUpsellComponent, {
    source: requestSource,
    module: moduleRequested,
    component: component,
  })
}

export const handleUpsellingOnClose = ({
  onClose,
  requestSource,
  moduleRequested,
  component,
}: OnCloseProps) => {
  if (onClose) {
    onClose()
  }
  track(trackingEvents.upsellingKit.dismissedProductUpsellComponent, {
    source: requestSource,
    module: moduleRequested,
    component: component,
  })
}

export const handleUpsellingVisibility = ({
  moduleRequested,
  requestSource,
  component,
}: VisibilityProps) => {
  track(trackingEvents.upsellingKit.viewedProductUpsellComponent, {
    source: requestSource,
    module: moduleRequested,
    component: component,
  })
}

export const handleUpsellingLearnMore = ({
  moduleRequested,
  requestSource,
  component,
}: VisibilityProps) => {
  track(trackingEvents.upsellingKit.clickedLearnMoreProductUpsellComponent, {
    source: requestSource,
    module: moduleRequested,
    component: component,
  })
}

export const buildUpsellOriginParam = (
  component: string,
  requestSource: string,
  category: string
): string => {
  const componentName = component
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('')

  const upsellOriginData = {
    request_source: requestSource,
    request_source_category: category,
    request_source_component: componentName,
  }
  return `upsell_origin=${encodeURIComponent(JSON.stringify(upsellOriginData))}`
}
